// @flow
import { connect } from 'react-redux';
import Airpods from '../components/Airpods';

import type { RootState } from "../../../index";

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    localValues: state.localValues,
  };
}

export default connect(mapStateToProps)(Airpods);



// WEBPACK FOOTER //
// ./src/modules/custom-products/Airpods/container/AirpodsContainer.js